import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { NAV_ENTRIES } from "../Helper/Constant";
import { setPageHeader } from "../Redux/Slice/PageHeaderSlice";
import { usePageHeaderActionsDispatch } from "./PageHeaderActionsProvider";

/** Syncs the page header title with the active navigation route. */
const RouteHeaderSync: React.FC = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const setActions = usePageHeaderActionsDispatch();

	const currentLabel = useMemo(() => {
		const path = location.pathname?.toLowerCase() ?? "/";
		const match = NAV_ENTRIES.find((entry) => entry.type === "item" && entry.to.toLowerCase() === path);
		return match && match.type === "item" ? match.label : "";
	}, [location.pathname]);

	useEffect(() => {
		if (currentLabel) {
			dispatch(setPageHeader({ title: currentLabel }));
		} else {
			dispatch(setPageHeader({ title: "" }));
		}
		setActions(null);
	}, [currentLabel, dispatch, setActions]);

	return null;
};

export default RouteHeaderSync;

